var map = {
	"./de.json": 7464,
	"./en.json": 2084,
	"./en_GB.json": 1568,
	"./es.json": 1267,
	"./fr.json": 3327,
	"./it.json": 3754,
	"./pl.json": 6711,
	"./pt.json": 9567,
	"./sv.json": 214,
	"./uk.json": 7739
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7576;